import { FunctionComponent, MouseEventHandler } from "react";
import { LogoBackground } from "../../server/types/index.js";
import styles from "../stylesheets/components/media-library-image.module.css";
import { PictureCategory } from "../types/index.js";
import MediaLibraryImageCheck from "./MediaLibraryImageCheck.js";
import MediaLibraryImageItem from "./MediaLibraryImageItem.js";

interface Props {
  url: string;
  onSelection?: MouseEventHandler<HTMLDivElement>;
  title?: string | null;
  isSelected?: boolean;
  imageCount?: number;
  category?: PictureCategory;
  background?: LogoBackground;
  width?: number;
  height?: number;
}

const MediaLibraryImage: FunctionComponent<Props> = ({
  title,
  url,
  isSelected = false,
  imageCount = 1,
  onSelection,
  category = "pictures",
  background = "light",
  width,
  height,
}) => {
  return (
    <MediaLibraryImageItem
      category={category}
      background={background}
      isSelected={isSelected}
      onClick={onSelection}
    >
      <img
        width={width}
        height={height}
        loading="lazy"
        className="FullImage"
        src={url}
        alt={title || ""}
        title={title || undefined}
      />

      {imageCount > 1 && (
        <div className={styles.MediaLibrary__Image__Count}>
          <span>+{imageCount}</span>
        </div>
      )}

      {isSelected && <MediaLibraryImageCheck />}
    </MediaLibraryImageItem>
  );
};

export default MediaLibraryImage;
